import React, { useState } from 'react'
import uniqueId from 'lodash/uniqueId'

import {
  FormContainer,
  FormBodyContainer,
  FormBody,
  FormFooter,
} from '~/views/components/elements/Forms'
import Button from '~/views/components/ui/Button'
import FieldSet from '~/views/components/ui/FieldSet'
import TextField from '~/views/components/ui/inputs/TextField'
import { isString } from 'shared/utils/type-guards'

interface Props {
  onSubmit(values: { name: string; email: string }): void
}

const RequestAccessForm: React.FC<Props> = ({ onSubmit }) => {
  const formId = `form-${uniqueId()}`
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')

  const handleChange =
    (stateSetter: React.Dispatch<React.SetStateAction<string>>) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (isString(event.target.value)) {
        stateSetter(event.target.value)
      }
    }

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    onSubmit({ name, email })
  }

  return (
    <FormContainer>
      <FormBodyContainer>
        <FieldSet>
          <FormBody id={formId} onSubmit={handleSubmit}>
            <TextField
              label="Full Name"
              name="userName"
              value={name}
              onChange={handleChange(setName)}
              fullWidth
              required
            />
            <TextField
              label="Email"
              type="email"
              name="userEmail"
              value={email}
              onChange={handleChange(setEmail)}
              fullWidth
              required
            />
          </FormBody>
        </FieldSet>
      </FormBodyContainer>
      <FormFooter>
        <Button raised large type="submit" form={formId}>
          Submit
        </Button>
      </FormFooter>
    </FormContainer>
  )
}

export default RequestAccessForm
